import { CellProps } from "@jsonforms/core";
import { withJsonFormsCellProps } from "@jsonforms/react";

import { Input } from "@/components/primitives/input";

function TextCellComponent({ data, handleChange, path, enabled }: CellProps) {
  return (
    <Input
      type="text"
      value={data ?? ""}
      onChange={(e) => handleChange(path, e.target.value || undefined)}
      disabled={!enabled}
      size="sm"
    />
  );
}

export const TextCell = withJsonFormsCellProps(TextCellComponent);
